<div class="device-setup-outer">
  <div class="device-step">
    <div class="complete-step">
      <div class="step-bullet"><span>1</span></div>
      <div class="check"></div>
      <div class="prog"></div>
      <p>Video</p>
    </div>

    <div class="complete-step">
      <div class="step-bullet"><span>2</span></div>
      <div class="check"></div>
      <div class="prog"></div>
      <p>Microphone</p>
    </div>

    <div class="complete-step">
      <div class="step-bullet"><span>3</span></div>
      <div class="check"></div>
      <div class="prog"></div>
      <p>Speakers</p>
    </div>

    <div class="complete-step">
      <div class="step-bullet"><span>4</span></div>
      <div class="check"></div>
      <div class="prog"></div>
      <p>Speed test</p>
    </div>
  </div>

  <div class="device-setup">
    <div>
      <h2>Set up complete</h2>
      <p>
        If you were able to successfully complete each step your device is properly configured. You can now continue to your session.
      </p>
    </div>

    <div></div>

    <div>
      <button class="btn-full btn-main-proceed" type="button" (click)="setDeviceSetupStage4()">Back</button>
      <button class="btn-full btn-main" type="button" (click)="redirectToSession()">Continue</button>
    </div>
  </div>
</div>
